import React from 'react';
import { useTranslation } from 'react-i18next';

import Table from '../../../../components/form/table';
import { getPerfectDateTime } from '../../../../utils';

const formatDate = (value) => {
  if (!value) {
    return '';
  }
  return getPerfectDateTime(new Date(value));
};

const DeliveryLogTable = ({ tableData }) => {
  const { t } = useTranslation();

  const items = tableData.map((tableItem) => {
    const attributes = tableItem.attributes;

    return {
      id: tableItem.id,
      created_at: attributes.created_at,
      normalized_serial: attributes.normalized_serial,
      device_model_name: attributes.device_model_name,
      requested_version: attributes.requested_version,
      served_version: attributes.served_version,
      firmware_filename: attributes.firmware_filename,
      firmware_file_size: attributes.firmware_file_size,
      firmware_sha256: attributes.firmware_sha256,
      remote_ip: attributes.remote_ip,
      user_agent: attributes.user_agent,
    };
  });

  const columns = [
    {
      label: t('at'),
      prop: 'created_at',
      labelClassName: 'w-full lg:w-2/12',
      className: 'w-full lg:w-2/12 flex-shrink-0',
      render: ({ created_at }) => formatDate(created_at),
    },
    {
      label: t('serial_number'),
      prop: 'serial',
      labelClassName: 'w-full lg:w-2/12',
      className: 'w-full lg:w-2/12 flex-shrink-0',
      render: ({ normalized_serial, device_model_name }) => (
        <div>
          <div className="font-medium text-gray-900">{normalized_serial}</div>
          <div className="text-gray-500">{device_model_name}</div>
        </div>
      ),
    },
    {
      label: t('firmware_versions'),
      prop: 'versions',
      labelClassName: 'w-full lg:w-2/12',
      className: 'w-full lg:w-2/12 flex-shrink-0',
      render: ({ requested_version, served_version }) => (
        <div>
          <div className="font-medium text-gray-900">{served_version}</div>
          <div className="text-gray-500">{requested_version || '-'}</div>
        </div>
      ),
    },
    {
      label: t('firmware_file'),
      prop: 'file',
      labelClassName: 'w-full lg:w-3/12',
      className: 'w-full lg:w-3/12 flex-shrink-0',
      render: ({ firmware_filename, firmware_sha256 }) => (
        <div>
          <div className="font-medium text-gray-900 break-all">{firmware_filename}</div>
          <div className="text-gray-500 break-all">{firmware_sha256}</div>
        </div>
      ),
    },
    {
      label: t('ip_address'),
      prop: 'request',
      labelClassName: 'w-full lg:w-3/12',
      className: 'w-full lg:w-3/12 flex-shrink-0',
      render: ({ remote_ip, user_agent }) => (
        <div>
          <div className="font-medium text-gray-900">{remote_ip}</div>
          <div className="text-gray-500 break-words">{user_agent}</div>
        </div>
      ),
    },
  ];

  return (
    <Table
      border={true}
      columns={columns}
      data={items}
      emptyText={t('no_data')}
    />
  );
};

export default DeliveryLogTable;
